import { faCube } from "@fortawesome/pro-regular-svg-icons";
import { twJoin } from "tailwind-merge";

import { Flow } from "src/api/flowTypes";
import { ResourceCardsContainer } from "src/base-components/ResourceCard";
import { EmptyState } from "src/design-system/EmptyState";
import { FlowCardV2 } from "src/flowsOverview/FlowCardV2";

type Props = {
  flows: Flow[];
  flowActions: {
    onCopy: (flow: Flow) => void;
    onDelete: (flow: Flow) => void;
    onRename: (flow: Flow) => void;
    onViewApiDocs: (flow: Flow) => void;
    onViewFlow: (flow: Flow) => void;
    onMove: (flow: Flow) => void;
    onRemoveFromFolder: (flow: Flow) => void;
  };
};

export const FlowListV2: React.FC<Props> = ({ flows, flowActions }) => {
  return (
    <ResourceCardsContainer placement="center">
      {flows.length === 0 ? (
        <div
          className={twJoin(
            "col-span-full h-full rounded-lg border border-gray-200 bg-gray-50",
            "p-8 lg:p-16",
          )}
        >
          <EmptyState
            description="Create a new Decision Flow or drag and drop an existing one into this folder."
            headline="This folder has no Decision Flows"
            icon={faCube}
          />
        </div>
      ) : (
        flows.map((flow: Flow) => (
          <FlowCardV2
            key={flow.id}
            flow={flow}
            onCopy={() => flowActions.onCopy(flow)}
            onDelete={() => flowActions.onDelete(flow)}
            onMove={() => flowActions.onMove(flow)}
            onRemoveFromFolder={() => flowActions.onRemoveFromFolder(flow)}
            onRename={() => flowActions.onRename(flow)}
            onViewApiDocs={() => flowActions.onViewApiDocs(flow)}
            onViewFlow={() => flowActions.onViewFlow(flow)}
          />
        ))
      )}
    </ResourceCardsContainer>
  );
};
